import React, { CSSProperties, FunctionComponent } from "react";

interface GoogleMapsMarkerProps {
  styles?: CSSProperties;
}

const googleMapMarkerLogoPath
  = "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Google_Maps_pin.svg/1200px-Google_Maps_pin.svg.png";

export const GoogleMapsMarker: FunctionComponent<GoogleMapsMarkerProps> = (
    props: GoogleMapsMarkerProps
) => {
    return (
        <img
            style={{
                height: "30px",
                width: "18px",
                marginRight: "4px",
                ...props.styles,
            }}
            src={googleMapMarkerLogoPath}
        />
    );
};
